import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { SnapshotAlarmSetting } from 'types';

export const getAlarmSettings = async (): Promise<SnapshotAlarmSetting> => {
  const { data }: { data: SnapshotAlarmSetting[] } = await axios.get(
    `/api/snapshots/alarms/snapshot-alarm-settings`
  );
  // The reference to index 0 is a placeholder while we only have a single config row in the
  //   snapshot-alarm-settings DB table
  const settings = data[0];
  return {
    ...settings,
    snmp_version:
      settings?.snmp_version === undefined || settings.snmp_version === null
        ? 0
        : settings.snmp_version,
  } as SnapshotAlarmSetting;
};

type QueryFnType = typeof getAlarmSettings;

type UseAlarmSettingsOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useAlarmSettings = ({ config }: UseAlarmSettingsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['alarms', 'settings'],
    queryFn: getAlarmSettings,
    ...config,
  });
};
